// extracted by css-extract-rspack-plugin
export default {"helperText":"product-detail-fragment__HelperText_helperText__TEnmO","isError":"product-detail-fragment__HelperText_isError__rTgEZ"};